module.exports = __webpack_public_path__ + "assets/img/footer-blob-top-left.7acef446.webp";